import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
const rows = [{
  have: 'Free drill libraries',
  gives: 'Drills to search through, one at a time.',
  adds: 'The full session: warm-up game, three stations, match game and huddle.'
}, {
  have: 'Kids’ starter programmes',
  gives: 'A few weeks of sessions for the youngest players.',
  adds: 'A whole season, from soft-ball nights to hard-ball cricket.'
}, {
  have: 'Your club’s coaching plan',
  gives: 'What to cover this season.',
  adds: 'The night-by-night sessions to cover it, with every player busy.'
}];

/** Shown in place of the second block of reviews until real ones come in. */
export function Alongside() {
  return <section aria-labelledby="alongside-heading" className="w-full bg-field-mid text-cream" data-id="element-22" data-mp="xvolpxols2bv">
      <div className="mx-auto max-w-5xl px-5 py-16 sm:py-20" data-id="element-23" data-mp="a63rujqwvknt">
        <div className="text-center" data-id="element-24" data-mp="65jtxdyikd0m">
          <p className="text-[11px] font-semibold uppercase tracking-[1.6px] text-willow" data-id="element-25" data-mp="64il7g4z02m2">Already have club resources?</p>
          <h2 id="alongside-heading" className="mt-3 font-display text-3xl text-cream sm:text-5xl" data-id="element-26" data-mp="22ikq5m98g279">
            Works alongside what your club already uses
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-sm text-cream/70 sm:text-base" data-id="element-27" data-mp="2c9ymxm9sunwp">
            Free drills, national-body programmes and your club&apos;s own plan are
            a great start. What they don&apos;t hand you is Tuesday&apos;s session,
            built for one coach, a couple of helpers and a big group.
          </p>
        </div>

        <ul className="mt-9 grid gap-4 md:grid-cols-3" data-id="element-28" data-mp="1ol5yeavibic4">
          {rows.map(row => <li key={row.have} className="flex flex-col rounded-2xl border border-field-line bg-field p-5 sm:p-6" data-id="element-29" data-mp="1tkikgtek0ldn">
              <p className="text-[11px] font-semibold uppercase tracking-widest text-cream/55" data-id="element-30" data-mp="34xl1fpkkfcyc">You have</p>
              <h3 className="mt-1 font-display text-lg font-extrabold leading-tight text-cream" data-id="element-31" data-mp="39wnyonub0evr">{row.have}</h3>
              <p className="mt-1.5 text-sm text-cream/65" data-id="element-32" data-mp="19tws22gsnw4d">{row.gives}</p>
              <div className="mt-4 flex items-start gap-2.5 border-t border-field-line pt-4" data-id="element-33" data-mp="19w98ucatg0fu">
                <span className="mt-0.5 flex h-5 w-5 flex-none items-center justify-center rounded-full bg-willow" data-id="element-34" data-mp="14xpjs30xe8j9">
                  <ArrowRightIcon className="h-3 w-3 text-willow-ink" aria-hidden="true" data-id="element-35" data-mp="1etj2631bsw8y" />
                </span>
                <p className="text-sm font-medium text-cream" data-id="element-36" data-mp="r3f1a3fivaln">
                  <span className="text-willow" data-id="element-37" data-mp="r1u92kgok3qy">No-Queue Cricket adds:</span> {row.adds}
                </p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}